export default __webpack_public_path__ + "static/media/bunny@3x.7b3ceeb5.png";